import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/chat/whatsapp-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3d7489d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-box" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftBox" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "iconImg"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "appName" }, "Whatsapp")
], -1))
const _hoisted_4 = { class: "rightBox" }
const _hoisted_5 = { class: "content" }

import { computed, ref } from "vue";
import leftTabs from "@/components/whatsapp/leftTabs.vue";
import rightContent from "@/components/whatsapp/rightContent.vue";
import datePicker from "@/components/whatsapp/datePicker.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { event } from "vue-gtag";
import { gaEvent } from '@/utils/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'whatsapp',
  setup(__props) {

const store = useStore();

const route = useRoute()

const whatsappFrom = computed(() => store.state.whatsappFrom)

if (whatsappFrom.value) {
  gaEvent("Whatsapp_PV", {
    event_category: "WhatsApp_Function",
    event_label: whatsappFrom.value,
  });
}



const handleDateChange = (value: any) => {
  store.commit("setDatePickerValue", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(datePicker, { onChange: handleDateChange })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(leftTabs),
      _createVNode(rightContent)
    ])
  ]))
}
}

})